export const AVATAR_SIZES = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
} as const

export const AVATAR_SIZES_ARRAY = Object.values(AVATAR_SIZES)
